export default "__VITE_ASSET__4fe390d9__"